export default __webpack_public_path__ + "static/NATURA LATEX-f88c89c44af1b75eaf8f04435628ffb4.png";